import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChCreateReferralMutation as useChCreateReferralMutationType } from "@/modules/patients/detail/referral/ch/services/__generated__/useChCreateReferralMutation.graphql"

const createReferralMutation = graphql`
  mutation useChCreateReferralMutation($input: Ch_createReferralLetterInput!) {
    ch_createReferralLetter(input: $input) {
      ch_ReferralLetter {
        id
        referralId
        progressNoteId
        careProviderIds
        progressNote {
          pointOfCare {
            careProvider {
              firstName
              lastName
              title
              businessName
              creditorCodeRegister
              city
              postalCode
              streetAddress
            }
          }
        }
        createdAt
        createdBy
        fileId
        fileMetadata {
          documentType
          extension
          lengthInKilobytes
        }
        patientId
        reasoning
        signedAt
        updatedAt
        updatedBy
        medicationIds
        conditions
        allergies
        documentLanguage
        concludedAt
        concludedBy
        careProvidersCopyTo {
          businessName
          title
          firstName
          lastName
          streetAddress
          postalCode
          city
        }
        icdDiagnosis {
          id
          isAssociation
          diagnosisCode
          primaryCode
          secondaryCode
          associationType
          text
        }
      }
      errors {
        ... on PatientIdIsRequired {
          message
        }
        ... on DocumentAlreadyExists {
          message
        }
      }
    }
  }
`

const useChCreateReferralMutation = () => {
  const [commit, isFlight] = useMutation<useChCreateReferralMutationType>(createReferralMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreateReferralMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreateReferralMutation }
